import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTrackCheckoutStep } from '../hooks'
import { CheckoutStepNameEnum } from '@config/seo/checkoutSteps'
import { CHECKOUT_PAGE_ROUTE } from './useTrackCheckoutPageStep'
import { parseUrlPathName } from '@corratech/pylot-tag-manager/src/utils/parseUrlPathName'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import { useUser } from '@corratech/pylot-auth-manager'

export const useTrackPaymentMethod = (): null => {
    const { isFallback, asPath } = useRouter()
    const { customer } = useUser()
    const {
        isGuestAddressFormVisible,
        setGuestAddressFormVisible
    } = useAlfakherContext()
    const trackCheckoutStep = useTrackCheckoutStep()
    const { data, isValidating } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    const isPaymentMethodSelected = customer
        ? 'true'
        : isGuestAddressFormVisible
    useEffect(() => {
        const methodTitle = cart?.selected_payment_method?.title
        if (parseUrlPathName(asPath) != CHECKOUT_PAGE_ROUTE) {
            setGuestAddressFormVisible(false)
        }
        if (
            isPaymentMethodSelected &&
            methodTitle &&
            !isFallback &&
            !isOptimistic &&
            !isValidating &&
            parseUrlPathName(asPath) === CHECKOUT_PAGE_ROUTE
        ) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.PAYMENT,
                option: methodTitle
            })
        }
    }, [cart, isFallback, isValidating, isOptimistic])

    return null
}
